import axios from 'axios'
import qs from 'qs'
export const topicService = ({
  getAllTopics (token) {
    return axios.get('/api/topics', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createTopic (token, topicName) {
    var topicObj = { TopicName: topicName }
    var stringifiedObj = qs.stringify(topicObj)
    return axios.post('api/topic/create', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteTopic (token, topicId) {
    return axios.delete('api/topic/delete?TopicId=' + topicId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateTopic (token, topicObj) {
    var stringifiedObj = qs.stringify(topicObj)
    return axios.put('/api/topic/update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/topic-service.js